export default __webpack_public_path__ + "static/media/user-pics-10.574657be.png";